import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { EventEmitterBo } from './claims.model';

@Component({
  selector: 'app-claims',
  templateUrl: './claims.component.html',
  styleUrls: ['./claims.component.scss']
})
export class ClaimsComponent implements OnInit {  
  claimListorEdit=false;

  constructor(public global:GlobalComponent,public dateservice:DateService,) { }

  ngOnInit(): void {
  }
  isListorUpdateView: EventEmitterBo = {
  isCreate: false,
  claimId:null,
  activeTab:null,
  currentpageno:1,
  pageitem:1,
  employeeId: null,
  clientId: null,
  companyId: null,
  payerId:null,
  resubmissionTypeLid:null,
  claimType:null,
  claimpaymentstatus: null,
  filterStartDate:null,
  filterEndDate:null,
  serviceId:null,
  interchangeControlNumber:null,
  patientControlNumber:null,
  payerClaimReferenceNumber:null,
  claimGridType: null,
  claimNote: null
  };

  EmitChildComponent(event: EventEmitterBo) {
    this.claimListorEdit = event.isCreate;
    this.isListorUpdateView = event;
  }
}
